import React, {useEffect, useState} from 'react';

import classNames from 'classnames';
import {isEmpty} from 'lodash';
import {
  Button,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import {useParams} from 'react-router';

import ContentTable from 'components/Contents/ContentTable';
import {LabelAddress} from 'components/Labels';

import useGetKeyLocations from './useGetKeyLocations';
import useGetCBStandardsLocation from './useGetCBStandardsLocation';

import styles from '../styles.module.scss';

const ScopeModal = (props) => {
  const {abId, cbId, toggle, location} = props;
  const {office_type, country_name, certification_bodies_location_id} =
    location;

  const {isLoading, data, reload} = useGetCBStandardsLocation(
    cbId,
    abId,
    certification_bodies_location_id
  );

  const title = office_type + ` (${country_name})`;

  useEffect(() => {
    if (!!location) reload();
  }, [location, office_type]);

  return (
    <Modal centered isOpen={!!location} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{office_type && title}</ModalHeader>
      <ModalBody style={{padding: '1.5rem'}}>
        <Container className={styles['table-container']}>
          <ContentTable
            v2
            hover={false}
            className="mb-0"
            minHeight="364px"
            responsive={false}
            isFetching={isLoading}
            head={['Standards and Schemes']}
          >
            {data.map((item, index) => {
              const {standards_name, scheme_name} = item;

              return (
                <tr key={index}>
                  <td>{[standards_name, scheme_name].join(' : ')}</td>
                </tr>
              );
            })}
          </ContentTable>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle} className="rounded">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

function CBAccreditationScopeKeyLocations(props) {
  const {selectedAB} = props;

  const {cbId} = useParams();
  const {isLoading, data, meta, reload} = useGetKeyLocations(cbId);
  const {total_rows} = meta || {};

  const [location, setLocation] = useState('');

  const toggle = (item) => {
    const isOpen = !item.target;
    if (isOpen) setLocation(item);
    else setLocation('');
  };

  const {accreditation_bodies_id} = selectedAB || {};

  useEffect(() => {
    if (!!accreditation_bodies_id) reload(accreditation_bodies_id);
  }, [accreditation_bodies_id]);

  const hideScope =
    !isEmpty(data) &&
    data.every((item) => {
      const {standard_schemes_count} = item;
      return standard_schemes_count === 0;
    });

  return (
    <Container className="p-0" tag="section">
      <h3 className={classNames(styles['section__title'], 'mb-4')}>
        Key Locations {`(${total_rows || 0})`}
      </h3>

      <Container className={styles['table-container']}>
        <ContentTable
          v2
          hover={false}
          className="mb-0"
          minHeight="364px"
          responsive={false}
          isFetching={isLoading}
          head={[
            'Office Type',
            'Country',
            'Address',
            !hideScope ? 'View Full Accreditation Scope' : '',
          ]}
        >
          {data.map((item, index) => {
            const {
              office_type,
              country_name,
              street,
              city,
              postcode,
              state,
              standard_schemes_count,
            } = item;

            return (
              <tr key={index}>
                <td>{office_type}</td>
                <td>{country_name}</td>
                <td>
                  <LabelAddress
                    street={street}
                    city={city}
                    state={state}
                    postcode={postcode}
                  />
                </td>
                {parseInt(standard_schemes_count) > 0 && (
                  <td>
                    <Button
                      outline
                      color="primary"
                      className="rounded"
                      onClick={() => toggle(item)}
                      disabled={isLoading}
                    >
                      View
                    </Button>
                  </td>
                )}
              </tr>
            );
          })}
        </ContentTable>
      </Container>

      <ScopeModal
        abId={accreditation_bodies_id}
        cbId={cbId}
        location={location}
        toggle={toggle}
      />
    </Container>
  );
}

export default CBAccreditationScopeKeyLocations;
